import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Query } from 'utility-ts-orm';
import { IApptSummariesDatasource } from '../datasources/appt_summaries_datasource';
import { INotesDatasource } from '../datasources/notes_datasource';
import { IProgressReportsDatasource } from '../datasources/progress_reports_datasource';

export class ReportsPriorityFeedQuery implements IQuery {
  private _result: any;
  private _count: number;

  constructor(
    private ngApptSummariesDatasource: IApptSummariesDatasource,
    private ngNotesDatasource: INotesDatasource,
    private ngProgressReportsDatasource: IProgressReportsDatasource
  ) {
    Query.registerQuery(this, this.ngApptSummariesDatasource, this.ngNotesDatasource, this.ngProgressReportsDatasource);
  }

  run(): this {
    this._result = {};
    const unreadApptSummaries = this.ngApptSummariesDatasource.query((report: any) => report.status === 'unread');
    const unreadNotes = this.ngNotesDatasource.query((report: any) => report.status === 'unread');
    const unreadProgressReports = this.ngProgressReportsDatasource.query((report: any) => report.status === 'unread');

    this._count = unreadApptSummaries.length + unreadNotes.length + unreadProgressReports.length;

    return this;
  }

  get result() {
    return this._result;
  }

  get count() {
    return this._count;
  }
}

angular.module('capability-ng-reports').service('ngReportsPriorityFeedQuery', ReportsPriorityFeedQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-reports/src/queries/reports_priority_feed_query.ts